import { getAccess } from '@/fsd/entities/access/api/getAccess/getAccess';
import { getAccount } from '@/fsd/entities/account/api/getAccount/getAccount';
import { getAccountCabinetMembership } from '@/fsd/entities/account/api/getAccountCabinetMembership/getAccountCabinetMembership';
import { CabinetApi } from '@/fsd/entities/cabinet/api';
import { LOCAL_STORAGE_ONBOARDING_SHOW_KEY } from '@/fsd/entities/onboarding/model/consts/consts';
import { api } from '@/fsd/shared/api';
import { makeAutoObservable, runInAction } from 'mobx';

export class UserStore {
  isLogged = !!localStorage.getItem('token');
  userInfo = null;
  token = null;
  isLoading = false;
  permissions = [];

  constructor() {
    makeAutoObservable(this);
    if (this.isLogged) {
      this.token = localStorage.getItem('token');
      this.initUser();
    }
  }

  async initUser() {
    this.isLoading = true;

    try {
      const [userInfo, permissions] = await Promise.all([
        this.getUserInfo(),
        this.getUserPermissions(),
      ]);

      console.log('initUser', '[userInfo, permissions]', [
        userInfo,
        permissions,
      ]);

      runInAction(() => {
        this.userInfo = userInfo;
        this.permissions = permissions;
        this.isLoading = false;
      });
    } catch (error) {
      console.error('Ошибка инициализации пользователя:', error);
    }
  }

  async getUserInfo() {
    try {
      return await getAccount();
    } catch (error) {
      console.error('Ошибка при получении информации о пользователе:', error);
      throw error;
    }
  }

  async getUserPermissions() {
    try {
      const [currentCabinet, cabinets, access, userInfo] = await Promise.all([
        CabinetApi.current(),
        CabinetApi.cabinets(),
        getAccess(),
        this.getUserInfo(),
      ]);

      const userId = userInfo.id;

      const isHead = cabinets.data.own_cabinets.find(
        (cabinet) => cabinet.id === currentCabinet.data.cabinet_id
      );

      if (isHead) {
        return access.data.find((role) => role.id === 1)?.permission ?? [];
      } else {
        const membership = await getAccountCabinetMembership();

        const currentMember = membership.find(
          (member) => member.user.id === userId
        );

        return (
          access.data.find((role) => role.id === currentMember?.access?.id)
            ?.permission ?? []
        );
      }
    } catch (error) {
      console.error('Ошибка при получении прав пользователя:', error);
      throw error;
    }
  }

  async handleOut() {
    try {
      localStorage.removeItem('token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem(LOCAL_STORAGE_ONBOARDING_SHOW_KEY);
      await api.post('/auth/token/logout', { body: this.userInfo?.user });

      runInAction(() => {
        this.isLogged = false;
        this.userInfo = null;
        this.permissions = [];
      });
    } catch (error) {
      console.error('Ошибка при выходе:', error);
    }
  }
}
